/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropertiesSigniCompletedTotal200ResponseMeta } from './propertiesSigniCompletedTotal200ResponseMeta';
import { PropertiesSigniCompletedTotalResource } from './propertiesSigniCompletedTotalResource';


export interface PropertiesSigniCompletedTotal200Response { 
    data: PropertiesSigniCompletedTotalResource;
    meta: PropertiesSigniCompletedTotal200ResponseMeta;
}

